import React from "react";
import { useContentModalManager } from "providers/content-modal-manager";
import ContentModal from "./ContentModal";
import RecordingDetail from "apps/user/learner/pages/recordings/recording-detail";
import SessionDetail from "apps/user/learner/pages/sessions/session-detail";

const MODAL_TYPES = {
  RECORDING: "recording",
  SESSION: "session",
};

const ContentModalRouter = () => {
  const { contentType, contentId, closeModal } = useContentModalManager();

  if (!contentType || !contentId) return null;

  let ModalContent = null;
  if (contentType === MODAL_TYPES.RECORDING) {
    ModalContent = <RecordingDetail recordingId={contentId} />;
  } else if (contentType === MODAL_TYPES.SESSION) {
    ModalContent = <SessionDetail sessionId={contentId} />;
  }

  return <ContentModal onClose={closeModal}>{ModalContent}</ContentModal>;
};

export default ContentModalRouter;
